var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cell-datetime",class:{'cell-datetime-sm': _vm.size === 'small'}},[_c('span',{staticClass:"date"},[_vm._v(_vm._s(_vm.date))]),(_vm.show_time)?_c('span',{staticClass:"time",class:{'time-sm': _vm.time_size === 'small', 'time-lg': _vm.time_size === 'large'}},[_vm._v(_vm._s(_vm.time))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }